import { formatPlans } from '@/lib/format'

export function PlanBadge({ plans }: { plans: string[] }) {
  return (
    <span
      className={`plan-badge ${plans.length === 0 ? 'plan-all' : 'plan-some'}`}
    >
      {formatPlans(plans)}
    </span>
  )
}
